import { updateObject } from "../Utility";
import {
  LANGUAGES_GET_START,
  LANGUAGES_GET_SUCCESS,
  LANGUAGES_GET_FAIL,
} from "../actions/LanguagesActions";

const initialState = {
  items: {},
  itemsArray: [],
  loading: false,
  fetched: false,
  error: null,
};

// GET:
const getLanguagesStart = (state, actions) => {
  return updateObject(state, {
    loading: true,
    error: null,
  });
};

const getLanguagesSuccess = (state, action) => {
  return updateObject(state, {
    items: action.languages.reduce((obj, item) => {
      obj[item.id] = item;
      return obj;
    }, {}),
    itemsArray: action.languages,
    loading: false,
    fetched: true,
    error: null,
  });
};

const getLanguagesFail = (state, action) => {
  return updateObject(state, {
    loading: false,
    error: action.error,
  });
};

const LanguagesReducer = (state = initialState, action) => {
  switch (action.type) {
    // GET:
    case LANGUAGES_GET_START:
      return getLanguagesStart(state, action);
    case LANGUAGES_GET_SUCCESS:
      return getLanguagesSuccess(state, action);
    case LANGUAGES_GET_FAIL:
      return getLanguagesFail(state, action);
    default:
      return state;
  }
};

export default LanguagesReducer;
